const evt = (entity) => ({
    CREATED: `pathway.${entity}.created`,
    UPDATED: `pathway.${entity}.updated`,
    DELETED: `pathway.${entity}.deleted`,
});

// SignalR entities: KEY -> backend event slug.
const SIGNALR_ENTITIES = {
    ENQUIRY: 'enquiry',
    CONTACT: 'contact',
    CHILD: 'child',
    CENTRE: 'centre',
    TOUR: 'tour',
    AVAILABILITY_RULE: 'availablerule',
    BLOCKED_RECURRING_RULE: 'blockedrecurringrule',
    COMMUNICATION: 'communication',
    NOTE: 'note',
    CHILD_AGE: 'childage',
    LANGUAGE: 'language',
    ETHNICITY: 'ethnicity',
    IWI: 'iwi',
    GENDER: 'gender',
    INTENT: 'intent',
    SOURCE: 'source',
    STATUS: 'status',
    SESSION: 'session',
    RELATIONSHIP: 'relationship',
    COMMUNICATION_TYPE: 'communicationtype',
    IDENTIFICATION_TYPE: 'identificationtype',
    TEMPLATE: 'template',
    TEMPLATE_TRIGGER: 'communicationtrigger',
    ENROLMENT: 'enrolment',
    WAITLIST: 'waitlist',
};

// signalR.service auto-registers a hub handler for every string value here.
const SIGNALR = { CONNECTED: 'signalr.connected', DISCONNECTED: 'signalr.disconnected' };
for (const [name, entity] of Object.entries(SIGNALR_ENTITIES)) {
    const { CREATED, UPDATED, DELETED } = evt(entity);
    SIGNALR[`${name}_CREATED`] = CREATED;
    SIGNALR[`${name}_UPDATED`] = UPDATED;
    SIGNALR[`${name}_DELETED`] = DELETED;
}

// Booking flow emits pathway.tour.booked directly.
SIGNALR.TOUR_BOOKED = 'pathway.tour.booked';
SIGNALR.TOUR_RESCHEDULED = 'pathway.tour.rescheduled';
SIGNALR.TOUR_CANCELLED = 'pathway.tour.cancelled';
SIGNALR.TOUR_COMPLETED = 'pathway.tour.completed';
SIGNALR.CENTRE_STATUS_UPDATED = 'pathway.centre.statusupdated';
SIGNALR.CHILD_STATUS_UPDATED = 'pathway.child.statusupdated';
SIGNALR.CENTRE_TOURS_UPDATED = 'pathway.centre.toursupdated';
SIGNALR.COMMUNICATION_INBOUND_RECEIVED = 'pathway.communication.inbound.received';
SIGNALR.COMMUNICATION_INBOUND_UPDATED = 'pathway.communication.inbound.updated';
SIGNALR.ENQUIRY_UNREAD_COUNT_UPDATED = 'pathway.enquiry.unreadcount.updated';
SIGNALR.ENQUIRY_DUPLICATE_REMOVED = 'pathway.enquiryduplicate.removed';
SIGNALR.ENQUIRY_TAG_ADDED = 'pathway.enquirytag.added';
SIGNALR.ENQUIRY_TAG_REMOVED = 'pathway.enquirytag.removed';
SIGNALR.COMMUNICATION_STATUS_UPDATED = 'pathway.communication.statusupdated';
SIGNALR.ENROLMENT_SUBMITTED = 'pathway.enrolment.submitted';
SIGNALR.ENROLMENT_FINALISED = 'pathway.enrolment.finalised';
SIGNALR.ENROLMENT_COMPLETED = 'pathway.enrolment.completed';
SIGNALR.ENROLMENT_CANCELLED = 'pathway.enrolment.cancelled';
SIGNALR.ENROLMENT_FILE_UPLOADED = 'pathway.enrolment.fileuploaded';
SIGNALR.ENROLMENT_FILE_DELETED = 'pathway.enrolment.filedeleted';
SIGNALR.WAITLIST_SUBMITTED = 'pathway.waitlist.submitted';
SIGNALR.WAITLIST_CLOSED = 'pathway.waitlist.closed';
SIGNALR.WAITLIST_CANCELLED = 'pathway.waitlist.cancelled';
SIGNALR.WAITLIST_FILE_UPLOADED = 'pathway.waitlist.fileuploaded';
SIGNALR.WAITLIST_FILE_DELETED = 'pathway.waitlist.filedeleted';
SIGNALR.PRESENCE_JOINED = 'pathway.presence.joined';
SIGNALR.PRESENCE_LEFT = 'pathway.presence.left';

const events = {
    LOGGED_IN: 'logged_in',
    LOGGING_IN: 'logging_in',
    FAILED_LOGIN: 'failed_login',
    LOGGED_OUT: 'logged_out',
    LOGGED_IN_AUTHORIZED: 'logged_in_authorized',
    HTTP_UNAUTHORIZED: 'http_unauthorized',
    CENTRE_DATA_LOADED: 'centre.data.loaded',
    CENTRE_DATA_UPDATED: 'centre.data.updated',
    SIGNALR,
};

export default events;
